module.exports = __webpack_public_path__ + "img/ext.58b54b75.jpg";